/*******************************************************************************
* Project: J-SIPHE
* Summary:
*    Define DateFormPipe Pipe
* History:
*    NghiaNX            2021/03/09    Create Date format pipe
******************************************************************************/

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
@Pipe({ name: 'DateFormatPipe' })
export class DateFormPipe implements PipeTransform {
    transform(date: string, format: string = 'yyyy年MM月'): string {
        if (date !== undefined && date != null && date !== '') {
            const pDate = new Date(Number(date.substring(0, 4)), Number(date.substring(4)) - 1);
            return new DatePipe('en-US').transform(pDate, format);
        } else {
            return '';
        }
    }
}
